import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "content"]

  connect() {
    // Setup escape key handler
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    // Unlock body scroll when modal is removed
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  open() {
    // Show the modal container
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("hidden")
    }

    // Lock body scroll when modal opens
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // Hide the modal container
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hidden")
    }

    // Unlock body scroll
    document.body.classList.remove("overflow-hidden")

    // Clear the turbo frame to close the modal (legacy support)
    const frame = document.getElementById("modal")
    if (frame) {
      frame.innerHTML = ""
    }
  }

  closeBackground(event) {
    // Only close if clicking directly on the backdrop, not on children
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    // Only close if clicking directly on the backdrop, not on children
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  preventClose(event) {
    // Prevent clicks inside modal from bubbling to backdrop
    event.stopPropagation()
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
